import { InjectionToken } from '@angular/core';
import { Auth, getAuth } from 'firebase/auth';

export const AUTH_TOKEN = new InjectionToken<Auth>('Firebase Auth', {
  providedIn: 'root',
  factory: () => getAuth()
});
